<div class="m-auto z-10 text-3xl md:text-7xl font-bold text-center" *ngIf="!isOnline">
    <span *transloco="let t">{{t('Your Internet Connection is unstable, please try again.')}}</span>
</div>
<router-outlet *ngIf="isOnline"></router-outlet>
